$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// $(document).ajaxError(function(e, error) {
//     var status = error.status;
//     showResponse('Token scaduto, verrà aggiornato a breve');
//     if (status === 500) {
//         $.ajax({
//             url: '/ajax/gettoken',
//             type: 'GET',
//             dataType: 'JSON',
//         })
//         .done(function(data) {
//             if (data.token) {
//                 $('meta[name="csrf-token"]').attr('content', data.token);
//             }
//         })
//         .fail(function() {
//             console.log("error");
//         })
//         .always(function() {
//             console.log("complete");
//         });
//     }
// });

$('[data-toggle="tooltip"]').tooltip();

/** Fix per modali multiple */
$('.modal').on('hidden.bs.modal', function (e) {
    if($('.modal').hasClass('in')) {
        $('body').addClass('modal-open');
    }    
});

/** Pulsante per lo slideToggle per un'altro elemento */
$('#sidebar').on('click', '[data-toggle="op-menu"]', function() {
    var target = $(this).data('target');
    $(target).slideToggle();
});

/** Gestione sidebar */
$('#sidebarCollapse').on('click', function () {
	$('#sidebar').toggleClass('activ');
});

/** Serve per evitare reinderizzamenti */
$('#page-preview :not("#linkcommenti")').on('click', 'a', function (event) {
    event.preventDefault();
});




// WEBPACK FOOTER //
// ./resources/assets/js/eventi.js